module.exports = __webpack_public_path__ + "static/people_img9-6f89c9e53efb9729665cfe4d7ec0eff8.png";